import React from "react";
import { useQuery } from "react-query";
import VehicleImage from "../../../VehicleImage";
import styles from "./style.module.css";
import RideService from "../../../../services/ride";
import { VehicleColorType } from "../../../../constants/vehicleColor";

const vehicleDotColor = (color) => {
  if (color === 'WHITE') {
    return (<div
      style={{
        background: VehicleColorType[color],
        border: '1px solid rgba(128,128,128)',
      }}
      className={styles.vehicleDot}
    ></div>)
  } else {
    return (<div
      style={{
        background: VehicleColorType[color],
      }}
    ></div>)
  }
};

export default React.memo(props => {
  const { data: driverImage } = useQuery(
    [ "driverImage", props.driver?.id ],
    RideService.getRideDriverPhoto,
    {
      retry: false,
      refetchOnWindowFocus: false,
      queryFnParamsFilter: args => args.slice(1),
    });

  if (!props.driver){
    return null;
  }

  return (
    <div className={styles.driverVehicleBlock}>
      <div className={styles.driverVehicleImg}>
        <div className={styles.driverImg}>
          <img
            src={ driverImage}
            alt={props.driver?.firstName}
          />
        </div>
        <div className={styles.vehicleImg}>
          <VehicleImage vehicleType={props.vehicle?.vehicleType} className={styles.vehicleLogo} />
        </div>
      </div>
      <div className={styles.driverVehicleInfo}>
        <div className={styles.driverName}>
          {props.driver?.firstName}
        </div>
        <div className={styles.vehiclePlate}>
          {props.vehicle?.licencePlate}
        </div>
        <div className={styles.vehicleDescription}>
          {vehicleDotColor(props.vehicle?.color)}
          {props.vehicle?.color + " " + props.vehicle?.make + " " + props.vehicle?.model}
        </div>
      </div>
    </div>
  );
});
